enum contractsTabEnum {
	accountTab = 0,
	documentsTab = 1,
}

export default contractsTabEnum